<template>
    <div class="">
        <div class="title_nav">
            <div @click="$router.go(-1)">
                <Icon name="arrow-left" style="margin-top:0.1rem" />
            </div>
            <div style="padding-top:0.05rem" class="nav_address">订单详情</div>
        </div>
        <div class="movie-box pad30 acea-row content">
            <div class="left-img">
                <img v-lazy="order.image_path" />
            </div>
            <div class="page-flex-1">
                <p class="page-margin-bottom01">{{ order.product_name }}</p>
                <p class="page-margin-bottom01">{{ order.spec_name }}</p>
                <p class="page-margin-bottom01 acea-row row-between">
                    <span>￥ {{ order.price }}*{{ order.number }}</span>
                    <!-- <span>{{order.ctripprice}}</span> -->
                </p>
            </div>
        </div>
        <div class="total">
            共计：<span>￥{{ order.total_amount }}</span>
        </div>
        <!-- 订单信息 -->
        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>订单号：{{ order.order_no }}</div>
                <div class="copy-data" :data-clipboard-text="order.order_no">复制</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>下单时间：{{ order._add_time }}</div>
                <div class="font-color-red" v-if="order._status._type == 3">待发货</div>
                <div v-if="order._status._type == 4">待收货</div>
                <div v-if="order._status._type == 5">已完成</div>
                <div v-if="order._status._type == 2">待支付</div>
            </div>
        </div>
        <!-- 同城配送 -->
        <div class="order_no" v-if="order.ship_type == 'delivery'">
            <div class="orderer acea-row row-between">
                <div>收货信息</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>姓名：{{ order.name }} {{ order.phone }}</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>收货地址：{{ order.city }}{{ order.area }}{{ order.addr }}</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>收货时间：{{ order.ship_date }}{{ order.ship_time_text }}</div>
            </div>
        </div>
        <!-- 快递配送 -->
        <div class="order_no" v-if="order.ship_type == 'same'">
            <div class="orderer acea-row row-between">
                <div>收货信息</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>物流公司：{{ order.express_cp }}</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>快递单号：{{ order.express_no }}</div>
            </div>
            <div class="orderer acea-row row-right row-middle ">
                    <div class=" bnt bg-color-red" @click="gotoLogistics(order)">物流查询</div>
            </div>
        </div>
        <!-- 门店自提 -->
        <div class="order_no" v-if="order.ship_type == 'shop'">
            <div class="orderer acea-row row-between">
                <div>收货信息</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>门店名称：{{ order.take_shop_name }}</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>快递员电话：{{ order.city }}{{ order.area }}{{ order.addr }}</div>
            </div>
        </div>

        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>下单人</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>联系方式：{{ order.buyer_phone }}</div>
            </div>
        </div>
        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>其他</div>
            </div>
            <div class="orderer acea-row row-between">
                <div>{{ order.buyer_msg }}</div>
            </div>
        </div>
        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>商品金额</div>
                <div>￥{{ order.price }}</div>
            </div>
        </div>
        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>配送费</div>
                <div>￥{{ order.ship_amount }}</div>
            </div>
        </div>
        <div class="order_no">
            <div class="orderer acea-row row-between">
                <div>商品附件费</div>
                <div>￥{{ order.charges }}</div>
            </div>
        </div>


    </div>
</template>
<script>
import { Icon } from "vant";
import { orderDgDetail } from "@api/cake.js"
import ClipboardJS from "clipboard";
const NAME = "UncleCakeDetail";
export default {
    name: NAME,
    components: {
        Icon
    },
    data: function () {
        return {
            order: {
                _status: {}
            },
            id: this.$route.params.id,//进入详情使用的id
        }
    },
    watch: {
        $route(n) {
            console.log(n);
            if (n.name === NAME && this.id !== n.params.id) {
                this.id = n.params.id;
                this.getDetail();
            }
        }
    },
    methods: {
        getDetail() {
            const id = this.id
            if (!id) return this.$dialog.error("订单不存在");
            orderDgDetail(id).then(res => {
                if (res.data) {
                    this.order = res.data
                }
            })
        },
        // 复制
        copyFn: function (id) {
            const clipboard = new ClipboardJS(id);
            clipboard.on("success", () => {
                this.$dialog.success("复制成功");
                clipboard.destroy();
            });
        },
         //查看物流
        gotoLogistics(order){
            this.$router.push({
          path: '/dglogistics/' + order.order_id
        })
        },
    },
    mounted() {
        this.getDetail();
        this.$nextTick(function () {
            let copybtn = document.getElementsByClassName("copy-data");
            this.copyFn(copybtn);
        });
    }
}
</script>
<style scoped>
.left-img {
    width: 2rem;
    margin-right: .1rem;
}

.left-img img {
    width: 100%;
    height: auto;
}

.total {
    width: 100%;
    text-align: right;
    padding-right: 0.3rem;
    background: white;
}

.total span {
    color: #ff0b46;
    font-size: 0.3rem;
    font-weight: 600;
}

.title_nav {
    display: flex;
    width: 100%;
    /* background: #fff; */
    height: 0.7rem;
    padding-left: 0.2rem;
    padding-top: 0.15rem;
    background: white;
}

.nav_address {
    width: 80%;
    text-align: center;
    margin-left: 0.4rem;
}

.content {
    margin-top: 0.15rem;
    background: white;
}

.orderer {
    padding: 0.05rem 0.4rem;
    width: 100%;
    background: white;
}

.order_no {
    background: white;
    padding: 0.3rem 0rem;
    border-top: 0.08rem solid #f5f1f1;
}
.bnt{
    width: 1.6rem;
    height: 0.5rem;
    background-color: #E93323;
    border-radius: 0.25rem;
    font-size: 0.24rem;
    text-align: center;
    line-height: 0.5rem;
}

</style>